import {useState} from "react";
import axios from "axios";
import {CheckCircleIcon, XCircleIcon} from "@heroicons/react/20/solid";

export default function ForgotPassword() {
    const [email, setEmail] = useState("")
    const [error, setError] = useState("")
    const [reset, setReset] = useState("")

    function handleEmailChange(e) {
        setEmail(e.target.value)
    }

    function onSubmit(event) {
        event.preventDefault()
        setError(undefined)
        setReset(undefined)
        axios.post(process.env.REACT_APP_API_URL + "forgot-password", {"username": email})
            .then(function (response) {
                if (response.data["success"] === true) {
                    console.log("Success")
                    setReset("Please check your email for a link to reset your password.")
                    setEmail("")
                } else {
                    setError(response.data["error"]["description"])
                }
            })
            .catch(function (error) {
                console.log(error);
                setError(error)
            });
    }


    return (
        <div className="flex min-h-full w-full flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <img
                    className="mx-auto h-12 w-auto"
                    src={process.env.REACT_APP_URL + "/images/logo-dark.png"}
                    alt="Your Company"
                />
                <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">Forgot Password?</h2>
            </div>

            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                    <form className="space-y-6" onSubmit={(e) => onSubmit(e)}>
                        { error && <div className="border-l-4 border-red-400 bg-red-50 p-4">
                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <XCircleIcon className="h-5 w-5 text-red-800" aria-hidden="true" />
                                </div>
                                <div className="ml-3">
                                    <p className="text-sm text-red-700">
                                        {error}
                                    </p>
                                </div>
                            </div>
                        </div>}
                        { reset && <div className="border-l-4 border-green-400 bg-green-50 p-4">
                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <CheckCircleIcon className="h-5 w-5 text-green-800" aria-hidden="true" />
                                </div>
                                <div className="ml-3">
                                    <p className="text-sm text-green-700">
                                        {reset}
                                    </p>
                                </div>
                            </div>
                        </div>}
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                Email address
                            </label>
                            <div className="mt-1">
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    autoComplete="email"
                                    onChange={handleEmailChange}
                                    required
                                    className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                />
                            </div>
                        </div>
                        <div>
                            <button
                                type="submit"
                                className="flex w-full justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            >
                                Send Password Reset
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
